<script lang="ts">
	import { formatDateDistance } from '@app/lib/utils/date';
	import { t } from 'svelte-i18n';
	import type { AdaptedOperationModel } from '@app/models/api/OperationModel';
	import FollowProject from './FollowProject.svelte';
	import Icon from '@app/lib/elements/Icon.svelte';
	export let props: AdaptedOperationModel;
	let statusClass = 'text-grey-dark';

	const getStatusMessage = (props: AdaptedOperationModel) => {
		switch (true) {
			case props.isOngoingClosing:
				return $t('operation.messages.ongoingClosing2');

			case props.isCollectComing:
				statusClass = 'text-warning';
				return `${$t('operation.messages.opening')} ${formatDateDistance(props.startDate)}`;

			case props.isCollectEnded:
				return $t('operation.messages.ongoingClosing');

			case props.isCollectAlmostEnd:
				statusClass = 'text-primary';
				return `${$t('operation.messages.closing')} ${formatDateDistance(props.collectEndDate)}`;

			case props.isCollectRunning:
				statusClass = 'text-success';
				return $t('operation.messages.ongoingCollect');

			default:
				return '';
		}
	};
</script>

<div class="{statusClass} flex justify-between items-center space-x-2">
	<Icon name="timer" size="small" />
	<span class="font-semibold text-sm">{getStatusMessage(props)}</span>
</div>
<div class="text-primary">
	<FollowProject operationId={props.id} follows={props.follows} />
</div>
